export default "__VITE_ASSET__hiNt4w$G__"